/**
 * AAA IDP homepage
 * 
 */
import React, { useRef, createElement as _createElement } from 'react';
import Banner from '../../components/banner/Banner';
import WhatIs from '../../components/what-is/WhatIs';
import HowTo from '../../components/how-to/HowTo';
import Need from '../../components/need/Need';
import Faq from '../../components/faq/Faq';
import Cta from '../../components/cta/Cta';
import Contact from '../../components/contact/Contact';
import HomeForm from './home-form/HomeForm';
import { SITE_CONTENT } from '../../reducers/content/Site.content';
import './Home.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Home = props => {
  const {
    bugsnagClient,
    content
  } = props;
  const {
    banner,
    form,
    contact,
    need,
    info,
    howTo,
    what,
    faq,
    cta
  } = content;
  const formRef = useRef();
  const pageRef = useRef();

  /**
   * Scroll the start application form into view
   */
  const startApp = (e, origin = 'banner') => {
    e.preventDefault();
    if (!pageRef || !pageRef.current || !formRef || !formRef.current) {
      return;
    }
    const page = pageRef.current.getBoundingClientRect();
    const dim = formRef.current.getBoundingClientRect();
    const top = origin === 'cta' ? Math.abs(Math.floor(page.top - dim.top)) + 96 : dim.top;
    window.scrollTo({
      top,
      behavior: 'smooth'
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "Home",
    ref: pageRef,
    children: [/*#__PURE__*/_jsx(Banner, {
      ...banner,
      startApp: startApp
    }), /*#__PURE__*/_jsxs("section", {
      className: "content-container",
      role: "main",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "what",
        children: what.title
      }), /*#__PURE__*/_jsx(WhatIs, {
        ...what
      }), /*#__PURE__*/_jsx("h2", {
        children: howTo.title
      }), /*#__PURE__*/_jsx(HowTo, {
        ...howTo
      }), /*#__PURE__*/_jsx(HomeForm, {
        ...form,
        bugsnagClient: bugsnagClient,
        formRef: formRef
      }), /*#__PURE__*/_jsx("h2", {
        className: "things-you-need",
        children: need.title
      }), /*#__PURE__*/_jsx(Need, {
        ...need
      }), /*#__PURE__*/_jsx("h2", {
        className: "faq",
        children: faq.mainTitle
      }), /*#__PURE__*/_jsxs("div", {
        className: "faq-container",
        children: [/*#__PURE__*/_jsx("div", {
          className: "faqs",
          children: faq.items.map((item, index) => {
            return /*#__PURE__*/_createElement(Faq, {
              ...item,
              key: index
            });
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "faq-post-copy",
          dangerouslySetInnerHTML: {
            __html: faq.postCopy
          }
        }), /*#__PURE__*/_jsx(Cta, {
          ...cta,
          startApp: startApp
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "Empowered",
      children: /*#__PURE__*/_jsx("div", {
        className: "inner",
        dangerouslySetInnerHTML: {
          __html: info
        }
      })
    }), /*#__PURE__*/_jsx(Contact, {
      ...contact
    })]
  });
};
Home.defaultProps = {
  content: {
    ...SITE_CONTENT
  },
  jest: false
};
export default Home;